import { useContext } from "react";
import { AuthenticationContext } from "components/context/AuthenticationProvider";

const useTranslateDomain = () => {
  const { appAxios } = useContext(AuthenticationContext);

  return (params) =>
    appAxios
      .post("/api/app/translate-domain/", params)
      .then((response) => {
        return response.data;
      })
      .catch(console.log);
};

export default useTranslateDomain;
